import { components } from "../types/api";
import { AssignedCampaign } from "../types/campaign";

export type Platform = components["schemas"]["_36_Enums.Platform"];
export type InternalPlatform =
  components["schemas"]["_36_Enums.InternalPlatform"];

export const DV360_INTERNAL_PLATFORMS: InternalPlatform[] = [
  "DV360",
  "DV360_VIDEO_BA",
  "DV360_DISPLAY_BA",
  "DV360_DATA_ENGAGE_BA",
  "DV360_DYNAMIC_IA_BA",
  "DV360_DATA_FEEL_BA",
];

export const GOOGLE_ADS_SUPPORTED_INTERNAL_PLATFORMS: InternalPlatform[] = [
  "GOOGLE_ADS_SEM",
  "GOOGLE_ADS_PMAX",
  "GOOGLE_ADS_DEMANDGEN",
];

export const CTV_SUPPORTED_INTERNAL_PLATFORMS: InternalPlatform[] = [
  ...DV360_INTERNAL_PLATFORMS,
  "AMAZON_DSP",
];

export const CTV_SOURCE_PLATFORMS: Platform[] = ["DV360", "AMAZON_DSP"];

export const isDv360InternalPlatform = (platform?: InternalPlatform) =>
  platform ? platform.startsWith("DV360") : false;

export const isGoogleAdsInternalPlatform = (platform?: InternalPlatform) =>
  platform ? platform.startsWith("GOOGLE_ADS") : false;

const INTERNAL_PLATFORM_LABELS: Record<InternalPlatform, string> = {
  DV360: "DV360",
  DV360_VIDEO_BA: "DV360 Video",
  DV360_DISPLAY_BA: "DV360 Display",
  DV360_DATA_ENGAGE_BA: "DV360 Data Engage",
  DV360_DYNAMIC_IA_BA: "DV360 Dynamic IA",
  DV360_DATA_FEEL_BA: "DV360 Data Feel",
  OUTBRAIN: "Outbrain",
  TABOOLA: "Taboola",
  SPOTIFY_ADS: "Spotify Ads",
  HIVESTACK: "Hivestack",
  AMAZON_DSP: "Amazon DSP",
  META: "Meta",
  TIKTOK: "TikTok",
  REDDIT: "Reddit",
  GOOGLE_ADS_SEM: "Google Ads (SEM)",
  GOOGLE_ADS_PMAX: "Google Ads (PMax)",
  GOOGLE_ADS_DEMANDGEN: "Google Ads (Demand Gen)",
};

export const getInternalPlatformDisplayName = (
  platform: InternalPlatform
): string => INTERNAL_PLATFORM_LABELS[platform] ?? platform;

export const mapPlatformToInternalPlatform = (
  platform?: string
): InternalPlatform => {
  switch (platform) {
    case "TABOOLA":
      return "TABOOLA";
    case "OUTBRAIN":
      return "OUTBRAIN";
    case "SPOTIFY_ADS":
      return "SPOTIFY_ADS";
    case "HIVESTACK":
      return "HIVESTACK";
    case "AMAZON_DSP":
      return "AMAZON_DSP";
    case "META":
      return "META";
    case "TIKTOK":
      return "TIKTOK";
    case "REDDIT":
      return "REDDIT";
    case "GOOGLE_ADS":
      return "GOOGLE_ADS_SEM";
    case "DV360":
    default:
      return "DV360_DISPLAY_BA";
  }
};

export const resolveAssignedInternalPlatform = (
  campaign: AssignedCampaign
): InternalPlatform => {
  if (campaign.internalPlatform) {
    return campaign.internalPlatform;
  }

  const campaignWithOriginal = campaign as AssignedCampaign & {
    originalPlatform?: string;
  };

  return mapPlatformToInternalPlatform(
    campaignWithOriginal.originalPlatform || campaign.platform
  );
};
